import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const FormText = ({ children, className, paragraphProps, ...rest }) =>
  children ? (
    <div
      className={classnames(
        'mt-2x',
        'mb-2x',
        'pb-2x',
        'pr-2x',
        'pt-2x',
        'input',
        'start-xs',
        className
      )}
      /* This is a workaround to get precedence over "input" class.
      Without, it'll be positioned in the end */
      style={{ justifyContent: 'flex-start' }}
      {...rest}
    >
      <p {...paragraphProps}>{children}</p>
    </div>
  ) : null;

FormText.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  paragraphProps: PropTypes.object
};

export default FormText;
